function initImageGallery(imageGallery) {
	if (!imageGallery) return;
	const mainImage = imageGallery.querySelector('.main-image');
	const subImages = imageGallery.querySelectorAll('.sub-images--wrapper .sub-image');
	if (!mainImage || !subImages) return;
	subImages.forEach((subImage) => {
		subImage.addEventListener('click', () => triggerImageGallery(imageGallery, mainImage, subImage))
	})
}

function triggerImageGallery(imageGallery, mainImage, subImage) {
	imageGallery.querySelectorAll('.sub-images--wrapper .sub-image img').forEach(el => el.classList.remove('active'));
	const currentSubImage = subImage.querySelector('img');
	currentSubImage.classList.add('active');
	if (!currentSubImage) return;
	const currentSubImageId = currentSubImage.getAttribute('image-id');
	const mainImageId = mainImage.querySelector('img').getAttribute('image-id');
	if (currentSubImageId !== mainImageId) {
		const clonedSubimage = currentSubImage.cloneNode(true);
		mainImage.replaceChildren(clonedSubimage);
	}
}

const imageGalleries = document.querySelectorAll('.image-gallery__wrapper');
if (imageGalleries) imageGalleries.forEach(imageGallery => initImageGallery(imageGallery));
